<i18n>
{
	"no": {
		"noFreightLines": "Det er ingen fraktlinjer ennå.",
		"freightLines": "Fraktlinjer",
		"packages": "Ingen kolli | {number} kolli | {number} kolli",
		"numberOfPackages": "",
		"description": "Beskrivelse",
		"grossWeight": "Br. vekt",
		"marks": "Merknad",
		"netWeight": "Nt. vekt",
		"quantity": "Mengde"
	},
	"en": {
		"noFreightLines": "There are no freight lines yet.",
		"freightLines": "Freight Lines",
		"packages": "packages",
		"numberOfPackages": "",
		"description": "Description",
		"grossWeight": "Gr. Weight",
		"marks": "Marks",
		"netWeight": "Nt. Weight",
		"quantity": "Quantity"
	}
}
</i18n>
<template>
	<div class="freightlines">
		<div class="freightlines-header">
			<t-panel-header
				:text="$tc('packages', getProperty(orderDetails,'numberOfPackages'))"
				icon="orders"
				size="md"
			/>
		</div>

		<t-grid
			v-if="getProperty(orderDetails,'freightLines') && orderDetails.freightLines.length > 0"
			:columnDefinitions="columnDefinitions"
			:rowHeight="50"
			:items="orderDetails.freightLines"
			:showFilters="false"
			idKey="lineNo"
			class="freightlines-grid"
		>
			<template v-slot:lineNo="{ item }">
				<t-pill size="small">{{item.lineNo}}</t-pill>
			</template>
		</t-grid>

		<t-no-content-panel v-else :text="$t('noFreightLines')" icon="order" />
	</div>
</template>

<script>
import { goodsTypesIcons, statuses } from '@/core';
export default {
	name: 'FreightLines',
	props: { orderDetails: Object },
	beforeMount() {
		this.columnDefinitions = [
			{
				field: 'lineNo',
				displayName: '#',
				width: 35,
				center: true,
			},
			{
				field: 'description',
				displayName: this.$t('description'),
				minWidth: 150,
				resizable: true,
			},
			{
				field: 'marks',
				displayName: this.$t('marks'),
				width: 150,
				resizable: true,
			},
			{
				field: 'netWeight',
				displayName: this.$t('netWeight'),
				type: 'number',
				width: 65
			},
			{
				field: 'grossWeight',
				displayName: this.$t('grossWeight'),
				type: 'number',
				width: 65
			},
			{
				field: 'numberOfUnits',
				displayName: this.$t('quantity'),
				type: 'number',
				width: 60
			},
		];
	},
	methods: {
		getProperty(object, propKey) {
			if (!object || !(propKey in object)) return '';
			return object[propKey];
		},
		getStatusIcon(item) {
			return goodsTypesIcons(item.goodsType);
		},
		getStatusColor(item) {
			return statuses.color(item.status);
		},
	}
};
</script>

<style>
.freightlines {
	height: 100%;
}

.freightlines-header {
	display:grid;
	padding: 15px;
	grid-template-columns: auto repeat(3, max-content);
	grid-column-gap: 20px;
	background: white;
}

.freightlines-grid {
	height: calc(100% - 60px);
	width: 100%;
}

</style>
